export default __webpack_public_path__ + "static/sidekick-c49a6eb1c9cf1a7d41cfdb696ac2240a.svg";